import { Directive, ElementRef, Input, NgZone, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[menu-size]'
})
export class MenuSizeDirective {
  @Input() blocoAberto: boolean;
  constructor(private el: ElementRef, private ngZone: NgZone) { }

  @HostListener('window:resize', ['$event']) onResize($event) {
    //ngZone.run will help to run change detection
    this.ngZone.run(() => {
      var incre:number = this.blocoAberto ? 319 : 139;
      $(".sidebar-scroll").css("height", (window.innerHeight - incre) + "px");    
    });
  }

  @HostListener('click', ['$event']) onClick($event) {
    var incre:number = this.blocoAberto ? 319 : 139;
    $(".sidebar-scroll").css("height", (window.innerHeight - incre) + "px");     
  }

  ngAfterViewInit() {
    var incre:number = this.blocoAberto ? 319 : 139;
    $(".sidebar-scroll").css("height", (window.innerHeight - incre) + "px");  
  }
}
